import React from 'react';
import PropTypes from 'prop-types';

export class WithLocation extends React.Component {
  state = {
    watchPositionId: -1,
    error: null,
    acquiring: true,
    LocationContext: null
  };

  componentDidMount() {
    // attempt to get the user's location when the component is loaded
    this.acquireLocation();
    this.state.LocationContext = React.createContext(null);
  }

  componentWillUnmount() {
    // Only need to clean up if using geolocation.WatchPosition
    const { watchPositionId } = this.state;
    const { mode } = this.props;

    if (mode === 'watch') {
      window.navigator.geolocation.clearWatch(watchPositionId);
    }
  }

  onLocationSuccess = position => {
    // returns https://developer.mozilla.org/en-US/docs/Web/API/Position
    this.setState({
      position,
      error: null,
      acquiring: false
    });
  };

  onLocationError = e => {
    // https://developer.mozilla.org/en-US/docs/Web/API/PositionError
    let locationErrorMessage;
    if (e.code === 1) {
      locationErrorMessage = 'Please allow iLancaster to access your location';
    } else if (e.code === 2) {
      locationErrorMessage = 'There was an error acquiring your loation';
    } else if (e.code === 3) {
      locationErrorMessage = 'We were unable to acquire your location';
    } else {
      locationErrorMessage = 'We were unable to acquire your location';
    }
    this.setState({ error: new Error(locationErrorMessage), acquiring: false });
  };

  refreshPosition = () => this.acquireLocation();

  stopWatchingPosition = () => {
    const { watchPositionId } = this.state;
    window.navigator.geolocation.clearWatch(watchPositionId);
  };

  acquireLocation = () => {
    const { geolocation } = window.navigator;
    const { mode } = this.props;
    const { watchPositionId } = this.state;
    const positionOptions = {
      enableHighAccuracy: true,
      timeout: 12000,
      maximumAge: 0
    };
    if (mode === 'watch') {
      geolocation.clearWatch(watchPositionId);
      geolocation.watchPosition(
        this.onLocationSuccess,
        this.onLocationError,
        positionOptions
      );
    } else {
      geolocation.getCurrentPosition(
        this.onLocationSuccess,
        this.onLocationError,
        positionOptions
      );
    }
  };

  render() {
    const { error, position, acquiring } = this.state;
    const { children } = this.props;

    return (
      <LocationContext.Provider
        value={{
          acquireLocation: this.acquireLocation,
          stopWatchingPosition: this.stopWatchingPosition,
          refreshPosition: this.refreshPosition,
          location: position,
          locationError: error,
          acquiringLocation: acquiring
        }}
      >
        {children}
      </LocationContext.Provider>
    );
  }
}

WithLocation.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  mode: PropTypes.string
};

WithLocation.defaultProps = {
  mode: 'singleGet'
};

export const LocationContext = React.createContext(null);
